export default __webpack_public_path__ + "static/media/spaces.2479a0f6.png";